import { requestActions } from "./utils";

export const DOWNLOAD = requestActions("Download");
export const RESET = "Download/Reset";

export const OPEN = "Download/Modal/Open";
export const CLOSE = "Download/Modal/Close";
